import { ReactElement } from "react";
import { Button } from "@justworkshr/milo-core";
import { DisplayIcon } from "@justworkshr/milo-icons";
import { WC_DOC_REQUEST_BASE_URL, WAIVER_EDIT_URL } from "../../constants";
import { Link } from "react-router-dom";

import styles from "./request-submitted.module.css";

const {
  customerSupport,
  requestReceived,
  waiverSubmission,
  waiverDescriptionButtons,
  centerGridItem,
  supportGridSection,
  mainGridSection,
  gridContainer,
} = styles;

export default function RequestSubmissionComplete(): ReactElement {
  const chatLink = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (window.Forethought) {
      window.Forethought("widget", "open");
    }
  };
  return (
    <div className={waiverSubmission}>
      <section className={`${requestReceived} ${gridContainer}`}>
        <span className={centerGridItem}>
          <DisplayIcon color="blue" iconName="check-on-page" size="large" />
        </span>
        <span className={mainGridSection}>
          <h1>Next steps for your waiver</h1>
          <ul>
            <li>
              We&apos;ll process this request with the insurance carrier and
              email you the approved waiver for you to provide to the relevant
              certificate holder.
            </li>
            <li>
              Please contact Customer Support if you don&apos;t receive the
              waiver within 3 - 5 business days.
            </li>
          </ul>
          <div className={waiverDescriptionButtons}>
            <Button to={WC_DOC_REQUEST_BASE_URL} as={Link}>
              Back to waiver & certificate requests
            </Button>
            <Button to={WAIVER_EDIT_URL} as={Link} variant="outlined">
              Submit another waiver of subrogation
            </Button>
          </div>
        </span>
      </section>
      <section className={`${customerSupport} ${gridContainer}`}>
        <span className={centerGridItem}>
          <DisplayIcon color="blue" iconName="shield" size="medium" />
        </span>
        <span className={supportGridSection}>
          <div>
            <h2>Need further assistance?</h2>
            <p>
              If you need more information or help regarding waivers of
              subrogation, reach out to our customer support team.
            </p>
          </div>
        </span>
        <span className={centerGridItem}>
          <Button variant="outlined" type="button" onClick={chatLink}>
            Contact support
          </Button>
        </span>
      </section>
    </div>
  );
}
